module.exports = __webpack_public_path__ + "static/media/im_7.bac91566.JPG";